import React from 'react';
import styled from '@emotion/styled/macro';

type CheckBoxProperties = {
  checked: boolean;
};
const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const Icon = styled.svg`
  fill: none;
  stroke: #ffffff;
  stroke-width: 3px;
`;
// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div<CheckBoxProperties>`
  display: inline-block;
  width: 24px;
  height: 24px;
  background: ${(props) => (props.checked ? '#00b292' : 'white')};
  border: ${(props) => (props.checked ? 'white' : '2px solid #26303e')};
  border-radius: 3px;
  transition: all 150ms;

  /* ${HiddenCheckbox}: focus + & {
    /* box-shadow: 0 0 0 3px pink; */
  /* }  */

  ${Icon} {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
  }
`;

type CheckboxProps = {
  className?: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  disabled?: boolean;
};

const Checkbox = ({ className, checked, disabled, ...props }: CheckboxProps) => (
  <CheckboxContainer className={className}>
    <HiddenCheckbox type="checkbox" checked={checked} disabled={disabled} {...props} />
    <StyledCheckbox checked={checked}>
      <Icon viewBox="0 0 24 24">
        <polyline points="20 6 9 17 4 12" />
      </Icon>
    </StyledCheckbox>
  </CheckboxContainer>
);

export default Checkbox;
